export const URLS = {
  MESSAGING_LOGS: '/messaging-logs/',
  ROUTE_SMS_BALANCE: '/route-sms-balance/',
  SEND_MESSAGE_TO_ROUTE: '/send-message-to-route/',
  ROUTE_EVENTS: '/route-events/',
};
